import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { PlaygroundService } from '../../../../services/playground.service';
import { ColumnMode, NgxDatatableModule } from '@m3rlin94/ngx-datatable';
import { SentimentClassPipe } from '../../../dashboard/tabular-view/pipes/sentiment-class-pipe.pipe';
import { FormattedValuePipe } from '../../../dashboard/tabular-view/pipes/formatted-value-pipe.pipe';
import { TruncateTopicPipe } from '../../../dashboard/tabular-view/pipes/truncate-topic-pipe.pipe';
import { FormatDatePipe } from '../../../dashboard/tabular-view/pipes/format-date-pipe.pipe';
import { TopicClassPipe } from '../../../dashboard/tabular-view/pipes/topic-class-pipe.pipe';
import { SentimentTextPipe } from '../../../dashboard/tabular-view/pipes/sentiment-text-pipe.pipe';
import { FormatTimestampPipe } from '../../../dashboard/tabular-view/pipes/format-timestamp-pipe.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UtcDateTimePipe } from '../../../../pipes/utc-date-time.pipe';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-playground-results',
  standalone: true,
  imports: [
    CommonModule,
    NgxDatatableModule,
    SentimentClassPipe,
    FormattedValuePipe,
    TruncateTopicPipe,
    FormatDatePipe,
    TopicClassPipe,
    SentimentTextPipe,
    MatTooltipModule,
    FormatTimestampPipe,
    UtcDateTimePipe,
  ],
  templateUrl: './playground-results.component.html',
  styleUrl: './playground-results.component.scss',
})
export class PlaygroundResultsComponent implements OnInit, OnDestroy {
  rows: any[] = [];
  loadingRow: any = null;
  columns = [
    { prop: 'contactId', name: 'CONTACT ID' },
    { prop: 'primaryTopic', name: 'PRIMARY TOPIC' },
    { prop: 'intent', name: 'INTENT' },
    { prop: 'topics', name: 'TOPICS' },
    { prop: 'sentimentAtStart', name: 'SENTIMENT AT START' },
    { prop: 'sentimentAtEnd', name: 'SENTIMENT AT END' },
    { prop: 'journeyMoment', name: 'JOURNEY MOMENT' },
    { prop: 'painPointCluster', name: 'PAIN POINT CLUSTER' },
    { prop: 'painPoint', name: 'PAIN POINT' },
    { prop: 'rootCauseCluster', name: 'ROOT CAUSE CLUSTER' },
    { prop: 'rootCause', name: 'ROOT CAUSE' },
    { prop: 'topicCluster', name: 'TOPIC CLUSTER' },
    { prop: 'topic', name: 'TOPIC' },
    { prop: 'summary', name: 'SUMMARY' },
    { prop: 'callerType', name: 'CALLER TYPE' },
    { prop: 'trigger', name: 'TRIGGER' },
    { prop: 'triggerClustered', name: 'TRIGGER CLUSTERED' },
    { prop: 'outcome', name: 'OUTCOME' },
    { prop: 'outcomeClustered', name: 'OUTCOME CLUSTERED' },
    { prop: 'callResolution', name: 'CALL RESOLUTION' },
  ];

  private subscription: Subscription = new Subscription();

  constructor(
    public playgroundService: PlaygroundService,
    private elementRef: ElementRef
  ) {
    // Initialize loading row
    this.loadingRow = {
      contactId: '',
      primaryTopic: '',
      intent: '',
      topics: [''],
      sentimentAtStart: '',
      sentimentAtEnd: '',
      journeyMoment: '',
      painPointCluster: [''],
      painPoint: '',
      rootCauseCluster: [''],
      rootCause: '',
      topicCluster: [''],
      topic: '',
      summary: '',
      callerType: '',
      trigger: '',
      triggerClustered: [''],
      outcome: '',
      outcomeClustered: [''],
      callResolution: '',
      isLoading: true,
    };
  }

  handleCellClick() {}

  readonly headerHeight = 50;
  readonly rowHeight = 55;
  ColumnMode = ColumnMode;
  reorderedColumn: string | null = null;

  trackByFn(index: number, item: any): any {
    return item.contactId || index;
  }

  onColumnReorder(event: any) {
    this.reorderedColumn = event.columns[event.newIndex].prop;
  }

  isEllipsisActive(element: HTMLElement): boolean {
    if (!element) return false;
    return element.scrollWidth > element.clientWidth;
  }

  ngOnInit() {
    // Subscribe to changes in processedData
    this.subscription.add(
      this.playgroundService.processedData$.subscribe((data: any[]) => {
        this.rows = data;
      })
    );

    // Subscribe to playground result status
    this.subscription.add(
      this.playgroundService.playgroundResultStatus$.subscribe((status: string) => {
        if (status === 'inProgress') {
          // Add loading rows if status is inProgress
          const loadingRows = Array(2).fill({ ...this.loadingRow });
          if (this.rows.length > 0) {
            this.rows = [...this.rows, ...loadingRows];
          } else {
            this.rows = loadingRows;
          }
        } else {
          // Remove loading rows if status is not inProgress
          this.rows = this.rows.filter((row) => !row.isLoading);
        }
      })
    );
  }

  ngOnDestroy() {
    // Clean up subscription
    this.subscription.unsubscribe();
  }
}
